export enum ETabName {
  COMPANY = "company",
  SECTOR = "sector",
  PROCESS_CENTER = "processCenter",
  AREA = "area",
  STORE = "store",
  USER = "user",
  CAMERA = "camera",
}
